import React from 'react';
import Header from '../../components/header/Header';
import orange_line from '../../images/orange-line.png';
import { Helmet } from 'react-helmet';
import privacy_policy from '../../database/privacy-policy.json';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = ({ headers }) => {
  const policy = JSON.parse(JSON.stringify(privacy_policy));

  // Recursive rendering function
  const renderContent = (contentArray) => {
    return contentArray.map((item, index) => {
      const { tag, content } = item;
      // Render content based on the tag
      switch (tag) {
        case 'h5':
          return <h5 key={index}>{content.join(' ')}</h5>;
        case 'p':
          return content.map((paragraph, i) => <p key={`${index}-${i}`}>{paragraph}</p>);
        case 'strong':
          return content.map((paragraph, i) => <strong key={`${index}-${i}`}>{paragraph}</strong>);
        case 'ul': {
          // Render a list with nested list items
          const listItems = item.content.map((listItem, i) => {
            const { tag: listItemTag, content2 } = listItem;
            if (listItemTag === 'li') {
              return content2.map((liContent, j) => <li key={`${i}-${j}`}>{liContent}</li>);
            }
            return null; // Ignore unsupported tags in lists
          });
          return <ul key={index}>{listItems}</ul>;
        }
        default:
          return null; // Ignore unsupported tags
      }
    });
  };

  const sections = policy.sections.map((section, index) => (
    <div key={index} className='section'>
      <h5 className='section-title'>
        {section.title}
        <img
          src={orange_line}
          className='orange-line'
          alt='decorative line'
        />
      </h5>
      <div className='section-content'>{renderContent(section.description)}</div>
    </div>
  ));

  return (
    <>
      <Helmet>
        <title>{policy.main_title}</title>
        <meta name='description' content='Learn more about Scisco Genetics' />
      </Helmet>
      <Header header={headers.filter((header) => header.key === 'policy')} />
      <div className='privacy-policy-container'>
        <p>{ policy.effective_date }</p>
        <div>{ sections }</div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
